<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="keywords"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of a keyword by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-keywordKey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                keywords: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getKeywords();
        },
        methods: {
            getKeywords:function(){
                axios.get('/api/keywords')
                .then(function(response){
                    var keywords = [];
                    response.data.forEach(function(record){
                        keywords.push({ text: record.name, value: record.keyword_key });
                    });
                    this.keywords = keywords;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
